var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useRef, useState } from "react";
export function delay(timeout) {
    return new Promise(r => setTimeout(r, timeout));
}
export function useMounted() {
    const mountedRef = useRef(true);
    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    }, []);
    return mountedRef;
}
function useDefaultResult(fn, value) {
    const [error, setError] = useState();
    const [result, setResult] = useState();
    const mounted = useMounted();
    useEffect(() => {
        (function () {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const res = yield fn(value);
                    if (mounted.current)
                        setResult(res);
                }
                catch (error_) {
                    if (mounted.current)
                        setError(error_);
                }
            });
        })();
    }, [fn, mounted, value]);
    return [result, error];
}
export function useDebounced(fn, timeout, defaultValue) {
    const [defaultResult] = useDefaultResult(fn, defaultValue);
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState();
    const mounted = useMounted();
    const threadRef = useRef();
    const executor = useCallback((value) => __awaiter(this, void 0, void 0, function* () {
        if (value === defaultValue) {
            setResult(defaultResult);
            threadRef.current = undefined;
            setLoading(false);
            return;
        }
        setLoading(true);
        const s = Symbol("executor");
        threadRef.current = s;
        yield delay(timeout);
        if (threadRef.current !== s)
            return;
        let res;
        try {
            res = yield fn(value);
        }
        catch (error_) {
            if (mounted.current)
                setError(error_);
        }
        if (mounted.current)
            setLoading(false);
        if (threadRef.current !== s)
            return;
        if (mounted.current)
            setResult(res);
    }), [defaultResult, defaultValue, fn, mounted, timeout]);
    return [result, loading, error, executor];
}
export default useDebounced;
//# sourceMappingURL=use-debounced.js.map